import { render } from "./v-textarea.vue?vue&type=template&id=53e7384c&scoped=true"
import script from "./v-textarea.vue?vue&type=script&lang=js"
export * from "./v-textarea.vue?vue&type=script&lang=js"

import "./v-textarea.vue?vue&type=style&index=0&id=53e7384c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e7384c"]])

export default __exports__